import type { DirectionalContextDto, PartnershipContextResponse } from '@/types'

type StoreSortFields = {
  isActive: boolean
  isRemote: boolean
}

export const compareStores = <T extends StoreSortFields>(left: T, right: T) =>
  Number(right.isActive) - Number(left.isActive) ||
  Number(left.isRemote) - Number(right.isRemote)

export const sortStores = <T extends StoreSortFields>(stores: T[]) =>
  [...stores].sort(compareStores)

const sortDirectionalStores = (direction: DirectionalContextDto) => ({
  ...direction,
  direct: direction.direct && {
    ...direction.direct,
    stores: sortStores(direction.direct.stores),
  },
  transit: direction.transit.map((group) => ({
    ...group,
    stores: sortStores(group.stores),
  })),
})

export const sortPartnershipContext = (
  context: PartnershipContextResponse
): PartnershipContextResponse => ({
  ...context,
  outgoing: sortDirectionalStores(context.outgoing),
  incoming: sortDirectionalStores(context.incoming),
})
